import React from "react";

function Experience() {
  return (
    <article className="experience">
      <h2>_Experience</h2>
      <p>
        I have worked with several freelance projects, as well as personal
        projects that i've built from scratch with technologies like ReactJs,
        MongoDb, Firebase, HTML5/CSS3 & several technology stacks.
        <br />
        Currently working as a Frontend Developer at @FaajiApp
      </p>
    </article>
  );
}

export default Experience;
